import { render, staticRenderFns } from "./NoDevice.vue?vue&type=template&id=76067022&scoped=true"
import script from "./NoDevice.vue?vue&type=script&lang=js"
export * from "./NoDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76067022",
  null
  
)

export default component.exports